<div class="vertical-container">
    <h1 style="font: 600 28px 'Poppins', sans-serif; max-width: 500px; text-align: center;">Dogo is extremely simple to operate with its minimal UI</h1>
    <br>
    <br>
    <div class="vertical-container details-container">
        <div *ngFor="let detail of details" class="detail-container horizontal-container">
            <div class="detail-info-container">
                <h1>{{ detail.title }}</h1>
                <br>
                <p>{{ detail.about }}</p>
            </div>
            <span class="filler"></span>
            <app-device [src]="detail.screenshot"></app-device>
        </div>
    </div>
</div>